import { Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { createVNode } from 'vue'
import { callOut } from '@/utils/Tccc'

/**
 *
 *  @param calleeName  被呼叫人的姓名
 *  @param calleeRole  被呼叫人的角色【患者，医生等】
 *  @param calleeType   被呼叫人角色代码 ，患者1 医生 2 BD 3
 *  @param calleeUcUserId   被呼叫人的ucUserId
 *  @param doctorId  医生id,注意不是用户中心id
 */
export const call = params => {
  const { calleeName, calleeRole, calleeType, calleeUcUserId, doctorId } = params
  Modal.confirm({
    centered: true,
    title: '确定拨打电话',
    icon: createVNode(ExclamationCircleOutlined),
    content: `确定给${calleeRole}-${calleeName}拨打电话吗？`,
    okText: '拨打',
    cancelText: '取消',
    onOk: () => {
      const params = {
        calleeType,
        calleeUcUserId,
        doctorId,
        workOrderIds: []
      }
      callOut(params, {
        userType: calleeRole,
        name: calleeName
      })
    }
  })
}
